const projects = {
  eatfit: {
    name: "EatFit",
    slug: "eatfit",

    privacyPolicy: `Privacy Policy for EatFit

Last updated: May 25, 2026

Developer / Company Name:
EatFit

Contact Email:
yadav.gaurav00729@gmail.com

Introduction

EatFit is a health and wellness application that provides healthy recipes, wellness tips, nutrition-related content, and personal fitness dashboards using Health Connect by Android.

Users may optionally connect their Health Connect account to allow the app to display health and fitness information such as steps, calories, workouts, sleep, heart rate, and related activity metrics directly inside the app dashboard.

EatFit only reads and displays Health Connect data provided by the user's device and authorized apps.

EatFit does not provide medical advice, diagnosis, or treatment.

By using EatFit, you agree to this Privacy Policy.

1. Information We Collect

A. Account Information

We may collect:
- Name
- Email address
- Basic profile information voluntarily provided by the user

B. Health Connect Data

If you choose to connect Health Connect, EatFit may request access to the following health and fitness data types:

- Steps
- Distance
- Active Calories Burned
- Total Calories Burned
- Floors Climbed
- Exercise Sessions
- Sleep Sessions
- Heart Rate
- Cycling Pedaling Cadence
- Steps Cadence

This access is requested only after explicit user permission through Android Health Connect.

EatFit only reads and displays this information for user-facing dashboard and wellness features.

Health Connect Data Purpose

The purpose of each Health Connect permission is:

- Steps: Display daily step count and activity trends.
- Distance: Display walking and running distance statistics.
- Active Calories Burned: Show calories burned through physical activity.
- Total Calories Burned: Display total daily energy expenditure.
- Floors Climbed: Show stair-climbing activity statistics.
- Exercise Sessions: Display workout history and workout summaries.
- Sleep Sessions: Display sleep duration and sleep trends.
- Heart Rate: Display heart rate information and wellness insights.
- Cycling Pedaling Cadence: Display cycling activity metrics and workout details.
- Steps Cadence: Display walking and running cadence metrics.

These permissions are used solely to provide user-facing dashboard and wellness features.

EatFit:
- does not modify Health Connect data
- does not write health records into Health Connect
- does not sell Health Connect data
- does not use Health Connect data for advertising
- does not share Health Connect data with unauthorized third parties

Health Connect data remains under the user's control.

EatFit only reads authorized Health Connect data and displays it to the user.

EatFit does not sell, rent, transfer, distribute, broker, or use Health Connect data for advertising, profiling, or marketing purposes.

Users may revoke Health Connect permissions at any time through Android Health Connect settings.

EatFit only requests the minimum data permissions necessary for app functionality.

C. Device and Usage Information

We may collect limited technical information such as:
- Device model
- Android version
- App version
- Crash logs
- Diagnostic information
- Performance analytics

This information is used only to improve app stability and performance.

2. How We Use Your Information

We use collected information only for the following purposes:

- Displaying health dashboards
- Showing activity summaries and trends
- Displaying recipes and wellness content
- Providing fitness insights
- Improving app performance and reliability
- Responding to support requests

Health Connect data is used only for in-app user-facing functionality.

3. No Medical Advice

EatFit is not a medical application and does not provide medical advice, diagnosis, treatment, emergency assistance, or healthcare services.

All recipes, calorie calculations, activity summaries, sleep information, fitness insights, wellness content, and health-related information are provided strictly for informational and educational purposes.

Users should always consult qualified healthcare professionals before making medical, dietary, exercise, fitness, or health-related decisions.

4. User Responsibility and Data Accuracy

Users are solely responsible for:
- verifying the accuracy of health data
- verifying nutrition information
- monitoring their own health conditions
- making personal fitness and health decisions

Health Connect data may vary depending on device sensors, connected fitness applications, wearable devices, or third-party integrations.

EatFit does not guarantee the accuracy, completeness, reliability, availability, or correctness of any health, fitness, calorie, sleep, workout, heart rate, or wellness information displayed within the app.

Users use the application entirely at their own risk.

5. Limitation of Liability

To the maximum extent permitted by law:

EatFit, its developers, owners, affiliates, and operators shall not be responsible for:

- inaccurate health data
- missing health data
- incorrect calorie calculations
- workout tracking errors
- recipe inaccuracies
- injuries
- medical complications
- health-related decisions
- damages resulting from inaccurate device data
- indirect, incidental, special, consequential, or punitive damages

arising from the use of the application.

6. Data Sharing

We do not sell personal data or health data.

We may share limited information only:

- with service providers necessary for app functionality
- when legally required
- to protect legal rights or prevent abuse
- with user consent

Health Connect data is never shared for advertising or marketing purposes.

7. Data Storage and Retention

EatFit may temporarily process or locally store certain health and wellness information on the user's device to provide dashboard functionality.

We retain personal information only for as long as necessary to:

- operate the application
- comply with legal obligations
- resolve disputes
- enforce agreements

8. User Controls and Data Deletion

Users may:

- disconnect Health Connect access at any time
- revoke permissions through Android Health Connect settings
- request deletion of account-related information by emailing:
  yadav.gaurav00729@gmail.com

We will make reasonable efforts to process valid deletion requests in accordance with applicable laws.

9. Data Security

We use reasonable technical and organizational measures to help protect user information.

However, no electronic storage system or internet transmission method can guarantee absolute security.

10. Children's Privacy

EatFit is not intended for children under 13 years of age.

We do not knowingly collect personal information from children under 13.

11. Third-Party Services

EatFit may contain links to third-party websites or services.

We are not responsible for the privacy practices, content, or policies of third-party services.

12. Changes to This Privacy Policy

We may update this Privacy Policy from time to time.

Updated versions will be posted within the application or on the official privacy policy page.

13. Contact Us

If you have questions regarding this Privacy Policy, contact us at:

Email:
yadav.gaurav00729@gmail.com`,

    terms: `Terms and Conditions for EatFit

Last updated: May 25, 2026

By downloading, accessing, or using EatFit, you agree to these Terms and Conditions.

EatFit provides recipes, wellness information, fitness dashboards, and Health Connect integrations for informational purposes only.

EatFit is not a medical device and does not provide medical advice, diagnosis, or treatment.

Users are responsible for verifying the accuracy of health information displayed in the application.

Health Connect information displayed in EatFit may depend on third-party applications, wearable devices, and device sensors. EatFit does not guarantee the accuracy or completeness of such information.

Users assume all risks associated with reliance on information provided within the application.

We reserve the right to modify, suspend, or discontinue any part of the application at any time.

For support or questions, contact:

yadav.gaurav00729@gmail.com`,
  },
};

export default projects;
